import { render, staticRenderFns } from "./Gift.vue?vue&type=template&id=18ec866a&scoped=true"
import script from "./Gift.vue?vue&type=script&lang=js"
export * from "./Gift.vue?vue&type=script&lang=js"
import style0 from "./Gift.vue?vue&type=style&index=0&id=18ec866a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ec866a",
  null
  
)

export default component.exports